import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

i18next.use(initReactI18next).init({
  interpolation: {
    // React already does escaping
    escapeValue: false,
  },
  lng: 'en-GB',
  fallbackLng: 'en-GB',
  // Using simple hardcoded resources for simple example
  resources: {
    'en-GB': {
      translation: {},
    },
    'it-IT': {
      translation: {},
    },
    'de-DE': {
      translation: {},
    },
  },
});

export default i18next;
